export enum CachingLevel{
  gestartet=0,
  Bauwerke=1,
  Rohre=2,
  Kabel=3,
  KabeltypDimension=4,
  KabeltypBündel=5,
  KabeltypFaseraufbau=6,
  Kabelgruppen=7,
  Kabeltypen=8,
  Etagen=9,
  Räume=10,
  Verteiler=11,
  Komponenten=12,
  KomponententypBezeichnung=13,
  DiensteaufdenVerbindungen=14,
  Dienste=15,
  RohrinRohr=16,
  PassthroughBauwerke=17,
  KabelinRohr=18,
  KabelPassthroughBauwerke=19,
  Rohrverbindungen=20,
  Kunden=21,
  VerteilerCache=22
}

export enum CachingLevelen{
  started=0,
  Buildings=1,
  Ducts=2,
  Cables=3,
  CableKindDimensions=4,
  CableKindBundles=5,
  CableKindItems=6,
  CableGroups=7,
  CableKinds=8,
  Floors=9,
  Rooms=10,
  Racks=11,
  Components=12,
  ComponentKindTexts=13,
  PortConnectionsServices=14,
  Services=15,
  DuctInDucts=16,
  PassthroughBuildings=17,
  CableInDucts=18,
  CablePassthroughBuildings=19,
  DuctConnections=20,
  Customers=21,
  RackCache=22
}
